import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip, X, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const open = async (eid) => {
  const win = window.open("", "_blank");
  try {
    const r = await api.get(`/audit/evidence/${eid}/file`, { responseType: "blob" });
    win.location.href = URL.createObjectURL(r.data);
  } catch (e) { win?.close(); toast.error("Datei konnte nicht geöffnet werden"); }
};

export function AuditEvidence({ periodId, goal, onChanged }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const upload = async (files) => {
    setBusy(true);
    try {
      for (const f of files) {
        if (f.size > 15 * 1024 * 1024) { toast.error(`${f.name}: Datei ist zu groß (max. 15 MB)`); continue; }
        const fd = new FormData();
        fd.append("file", f);
        await api.post(`/audit/periods/${periodId}/goals/${goal.id}/evidence`, fd);
      }
      toast.success("Nachweis hochgeladen");
      onChanged();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  const remove = async (e) => {
    if (!window.confirm(`Nachweis „${e.filename}" löschen?`)) return;
    await api.delete(`/audit/evidence/${e.evidence_id}`);
    toast.success("Nachweis gelöscht");
    onChanged();
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5 mt-1" data-testid={`fb-evidence-${goal.id}`}>
      {(goal.evidence || []).map((e) => (
        <span key={e.evidence_id} className="inline-flex items-center gap-1 border border-slate-200 bg-slate-50 px-1.5 py-0.5 text-[11px]" data-testid={`fb-evidence-item-${e.evidence_id}`}>
          <button type="button" onClick={() => open(e.evidence_id)} className="text-slate-700 hover:underline max-w-[160px] truncate" data-testid={`fb-evidence-open-${e.evidence_id}`}>{e.filename}</button>
          <button type="button" onClick={() => remove(e)} className="text-slate-400 hover:text-red-600" data-testid={`fb-evidence-del-${e.evidence_id}`}><X size={11} /></button>
        </span>
      ))}
      <input ref={ref} type="file" multiple accept=".pdf,.png,.jpg,.jpeg" className="hidden" onChange={(e) => e.target.files.length && upload([...e.target.files])} data-testid={`fb-evidence-input-${goal.id}`} />
      <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="inline-flex items-center gap-1 text-[11px] text-slate-500 hover:text-slate-900 disabled:opacity-50" data-testid={`fb-evidence-add-${goal.id}`}>
        {busy ? <Loader2 size={11} className="animate-spin" /> : <Paperclip size={11} />} Nachweis
      </button>
    </div>
  );
}
